import { DEFAULT_STAGE_VALUE_OVERVIEW } from '@gp/constants/const';
import { SortType } from '@gp/enums/common';

import type { Action, Reducer } from 'umi';
import type { IPayload } from '@gp/types/global';

export interface ILockerData {
  lock: boolean;
  filter: IPipelineProjectListFilterVO;
  ppsViewVisible: boolean;
  sort: IPipelineProjectListSortVO;
  search: IPipelineProjectListSearchVO;
}

type IUpdateLockerDataAction = Action<'updateLockerData'> & IPayload<ILockerData>;
type IClearLockerDataAction = Action<'clearLockerData'> & IPayload<unknown>;

interface ILockerModel {
  namespace: string;
  state: ILockerData;
  reducers: {
    updateLockerData: Reducer<ILockerData, IUpdateLockerDataAction>;
    clearLockerData: Reducer<ILockerData, IClearLockerDataAction>;
  };
  effects: {};
}

export const LOCKER_MODEL_NAMESPACE = 'dbg-model-pipeline-project-list-locker';

export const DEFAULT_FILTER: IPipelineProjectListFilterVO = {
  pteam: [],
  business_owner: [],
  studio: [],
  platform: [],
  milestone: [],
  next_milestone: [],
  publisher: [],
  status: [],
  stage: DEFAULT_STAGE_VALUE_OVERVIEW,
  form: [],
};

export const DEFAULT_SORT: IPipelineProjectListSortVO = {
  sort_type: SortType.Desc,
  sort: 'priority',
};

export const DEFAULT_SEARCH: IPipelineProjectListSearchVO = {
  search_type: '',
  search: [],
  searchVal: '',
  searchList: [],
};

const DEFAULT_LOCKER_DATA: ILockerData = {
  lock: false,
  filter: DEFAULT_FILTER,
  ppsViewVisible: false,
  sort: DEFAULT_SORT,
  search: DEFAULT_SEARCH,
};

const LockerModel: ILockerModel = {
  namespace: LOCKER_MODEL_NAMESPACE,
  state: DEFAULT_LOCKER_DATA,
  reducers: {
    updateLockerData(state, action) {
      return { ...state, ...action?.payload, lock: true };
    },
    clearLockerData(state) {
      return { ...state, ...DEFAULT_LOCKER_DATA, lock: false };
    },
  },
  effects: {},
};

export default LockerModel;
